import { app_id } from '@/services/compiler-refactor/xmlConvert/dataSource';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { Description } from '@/types/watchface';

// 不同设备对应的协议号
// const resolutionWithProtocol: Record<string, string[]> = {
//   XMHD01: ['1.8.11', '1.8.16', '1.8.17', '1.9.0'],
//   XMHD02: ['1.8.10'],
//   XMHD03: ['1.8.14', '1.8.17'],
//   XMHD04: ['1.8.14'],
//   XMHD05: ['1.8.17']
// };

// const getProtocolByResolution = (resolution: string, protocolByAst: string) => {
//   const protocols = resolutionWithProtocol[resolution];
//   let protocol = protocolByAst;
//   let flag = true;
//   protocols.map((p) => {
//     if (flag) {
//       if (p === protocol) {
//         flag = false;
//         return;
//       }
//       const numP = p.split('.').map((n) => Number(n));
//       const numPByAst = protocol.split('.').map((n) => Number(n));
//       for (let i = 0; i < numP.length; i++) {
//         if (numP[i] > numPByAst[i]) {
//           protocol = p;
//           flag = false;
//           return;
//         }
//       }
//     }
//   });
//   return protocol;
// };

// 协议1.9.4
// 功能点1 表盘中有容器跟随
const protocol1904 = (resAst: Ast) => {
  const slotRes = resAst.children.filter((item) => item.tag === 'Slot');
  if (slotRes.find((item) => item.attrsMap.SlotGroupName)) return true;
  else return false;
};

// 协议1.9.3
// 功能点1 表盘中有多视频或多序列帧
const protocol1903 = (resAst: Ast) => {
  const multiSpriteRes = resAst.children.filter(
    (item) => item.tag === 'SpriteGroup'
  );
  if (multiSpriteRes.length) return true;
  else return false;
};

// 协议1.9.2
// 功能点1 表盘需要自动Offloading以及可交互
const protocol1902 = (interactive: string, advanced: string) => {
  if (interactive === 'true' || advanced === 'true') return true;
};

// 协议1.9.1
// 功能点1 跳转三方应用微信
// 功能点2 layout可以为负数
// 功能点3 文字表盘
const protocol1901 = (layoutAst: Ast[], resAst: Ast, deviceType: string) => {
  /** N67使用文字表盘，暂时配置V8，后期N67会升级 */
  if (deviceType === 'N67') return false;
  const widgetRes = resAst.children.filter((item) => item.tag === 'Widget');
  if (
    widgetRes.find((item) => {
      const { jumpApp } = item.attrsMap;
      const index = app_id.findIndex((id) => jumpApp === id.split('@')[0]);
      if (jumpApp && (jumpApp === 'wechat' || index == -1)) return true;
    })
  )
    return true;
  else if (
    layoutAst.find(
      (item) => Number(item.attrsMap.y) < 0 || Number(item.attrsMap.x) < 0
    )
  )
    return true;
  else if (
    widgetRes.find((item) => {
      const { minClickZone } = item.attrsMap;
      if (minClickZone) return true;
    })
  )
    return true;
  else {
    const textRes = resAst.children.filter(
      (item) => item.tag === 'DataItemText'
    );
    const found = textRes.some((item: Ast) => {
      const { literal_num } = item.attrsMap;
      return literal_num !== undefined;
    });
    if (found) return true;
    return false;
  }
};

// 协议1.9.0
// 功能点1 ifttt
// 功能点2 视频和自定义视频表盘
const protocol1900 = (resAst: Ast, themeAst: Ast) => {
  if (
    resAst.children.find(
      (child) => child.tag === 'Condition' || child.tag === 'Animation'
    )
  )
    return true;
  const { bg, isPhotoAlbumWatchface } = themeAst.attrsMap;
  if (bg && bg.indexOf('Sprite') !== -1 && isPhotoAlbumWatchface === 'true')
    return true;
  const fileRes = resAst.children.filter((item) => item.tag === 'File');
  const foundVideo = fileRes.some((item: Ast) => {
    return item.attrsMap.name.endsWith('.mp4');
  });
  if (foundVideo) return true;
  return false;
};

/** N67使用文字表盘，暂时配置V8，后期N67会升级 */
const protocol1819 = (resAst: Ast, deviceType: string) => {
  /** N67使用文字表盘，暂时配置V8，后期N67会升级 */
  if (deviceType !== 'N67') return false;
  const textRes = resAst.children.filter((item) => item.tag === 'DataItemText');
  const found = textRes.some((item: Ast) => {
    const { literal_num } = item.attrsMap;
    return literal_num !== undefined;
  });
  if (found) return true;
  return false;
};

// 协议1.8.18
// 功能点1 跳转运动且有子类运动
// 功能点2 计算图组内存为单张图片
const protocol1818 = (resAst: Ast, desc: Description) => {
  const widgetRes = resAst.children.filter((item) => item.tag === 'Widget');
  if (
    widgetRes.find(
      (item) => item.attrsMap.jumpApp === 'sport' && item.attrsMap.args
    )
  )
    return true;
  const _isCalculateRamOnSingleImage = desc.imageArrayRamMethod === 'single';

  if (_isCalculateRamOnSingleImage) return true;
  return false;
};

// 协议1.8.17
// 功能点1 压缩方式为ezip
// 功能点2 图片格式为png/jpeg
// 功能点3 有功耗等级判断
const imgFormat1817 = ['png', 'jpeg'];
const protocol1817 = (
  resAst: Ast,
  compressMethod: string,
  powerConsumptionLevel?: string
) => {
  if (compressMethod === 'ezip' || powerConsumptionLevel) return true;
  else {
    const imgAndImgArrayRes = resAst.children.filter(
      (item) => item.tag === 'Image' || item.tag === 'ImageArray'
    );
    const found = imgAndImgArrayRes.some((item: Ast) => {
      const { format } = item.attrsMap;
      return format && imgFormat1817.includes(format.toLowerCase());
    });
    if (found) return true;
    else return false;
  }
};

// 协议1.8.16
// 功能点1 多配色表盘
// 功能点2 弧形文本有垂直对齐verticalAlign属性
// 功能点3 双时区表盘
// 功能点4 有天气当前风向或双时区数据源
const protocol1816 = (resAst: Ast, colorGroupTable: string) => {
  if (colorGroupTable?.length) return true;
  else {
    const textRes = resAst.children.filter(
      (item) => item.tag === 'DataItemText'
    );
    const found = textRes.some((item: Ast) => {
      const { verticalAlign } = item.attrsMap;
      return verticalAlign !== undefined;
    });
    if (found) return true;
    const slotRes = resAst.children.filter((item) => item.tag === 'Slot');
    const found2 = slotRes.some((item: Ast) => {
      const { type } = item.attrsMap;
      return type === 'dualTime';
    });
    if (found2) return true;
    const sourceArr = resAst.children
      .map((child) => child.attrsMap.source)
      .filter((src) => src !== undefined);
    const fonud3 = sourceArr.some((src) => {
      return (
        src === 'weatherCurrentWindDirection' || src.indexOf('dualTime') !== -1
      );
    });
    if (fonud3) return true;
    return false;
  }
};

// 协议1.8.14
// 功能点1 slot容器有appWidget类型或Position子元素
// 功能点2 有miscTimeSection时间段数据源
const protocol1814 = (resAst: Ast) => {
  const slotRes = resAst.children.filter((item) => item.tag === 'Slot');
  const found1 = slotRes.some((item: Ast) => {
    const { type } = item.attrsMap;
    const children = item.children;
    return (
      type === 'appWidget' || children.find((child) => child.tag === 'Position')
    );
  });
  if (found1) return true;
  const sourceArr = resAst.children
    .map((child) => child.attrsMap.source)
    .filter((src) => src !== undefined);
  const fonud2 = sourceArr.some((src) => {
    return src === 'miscTimeSection';
  });
  if (fonud2) return true;
  return false;
};

// 协议1.8.11
// 功能点1 有文件类型File
// 功能点2 有翻译类型Translation
const protocol1811 = (resAst: Ast) => {
  const fileRes = resAst.children.filter((item) => item.tag === 'File');
  if (fileRes.length) return true;
  const translationRes = resAst.children.filter(
    (item) => item.tag === 'Translation'
  );
  if (translationRes.length) return true;
  return false;
};

/**
 * 根据表盘功能，返回协议版本
 * @param watchfaceAst
 * @param desc
 * @returns
 */
export const getProtocol = (watchfaceAst: Ast, desc: Description) => {
  const { deviceType } = useWatchfaceStore();
  const {
    compressMethod,
    colorGroupTable,
    powerConsumptionLevel,
    interactive,
    advanced
  } = watchfaceAst.attrsMap;
  const resAst = watchfaceAst.children[0];
  const layoutAst: Ast[] = [];
  watchfaceAst.children.map((item) => {
    if (item.tag === 'Theme') {
      item.children.map((layout) => {
        layoutAst.push(layout);
      });
    }
  });
  const themeAst = watchfaceAst.children[1];
  const protocolByAst = protocol1904(resAst)
    ? '1.9.4'
    : protocol1903(resAst)
    ? '1.9.3'
    : protocol1902(interactive, advanced)
    ? '1.9.2'
    : protocol1901(layoutAst, resAst, deviceType)
    ? '1.9.1'
    : protocol1900(resAst, themeAst)
    ? '1.9.0'
    : protocol1819(resAst, deviceType)
    ? '1.8.19'
    : protocol1817(resAst, compressMethod, powerConsumptionLevel)
    ? '1.8.17'
    : protocol1818(resAst, desc)
    ? '1.8.18'
    : protocol1816(resAst, colorGroupTable)
    ? '1.8.16'
    : protocol1814(resAst)
    ? '1.8.14'
    : protocol1811(resAst)
    ? '1.8.11'
    : '1.8.10';
  return protocolByAst;
};
